import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Public web SDK config for the gerns-world Firebase project. These values
// identify the project — they're not secrets and are safe to ship in the
// client bundle. Same project as web-admin so a single Firebase identity
// works across admin tooling and customer-facing webapp.
const firebaseConfig = {
  apiKey: 'AIzaSyAPItpc3ztudKKDfrUVqZJzk-6goqME7Eg',
  authDomain: 'gerns-world.firebaseapp.com',
  projectId: 'gerns-world',
  storageBucket: 'gerns-world.firebasestorage.app',
  messagingSenderId: '44262946707',
  appId: '1:44262946707:web:bdd72588d3ec761d745a66',
  measurementId: 'G-9V7P8GZJG0',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
